import { tv } from '~/utils/tv'

export const CardInformativeContentVariants = tv({
  base: 'flex flex-col justify-center align-middle',
  variants: {},
})
